import React from "react"
import styled from "styled-components"
import { Container } from "../global"
import appstore from "../../images/appstore.png"
import google from "../../images/google.png"

const Header = () => (
  <HeaderWrapper id="top">
    <Container style={{ paddingLeft: "36px", paddingRight: "36px" }}>
      <Flex>
        <HeaderTextGroup>
          <Subtitle>Daily intentions, together</Subtitle>
          <h1>
            Make today Day One <Sun>☀️</Sun>
          </h1>
          <h2>
            Set your intentions. Add your day. Get cheered on by people doing
            the same — and earn Bitcoin for showing up.
          </h2>
          <StoreBadges>
            <a href="https://apps.apple.com/us/app/day-the-dailyness-app/id1555873146">
              <img src={appstore} alt="Download on the App Store" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.perfectdayreactnative">
              <img src={google} alt="Get it on Google Play" />
            </a>
          </StoreBadges>
          <FreeLine>Free to download. Free to play. Real sats.</FreeLine>
        </HeaderTextGroup>
        <PhoneWrapper>
          <Phone>
            <PhoneTop>
              <AvatarAura>
                <Avatar>😊</Avatar>
              </AvatarAura>
              <PhoneGreeting>
                <strong>Day 128</strong>
                <span>🔥 12-day streak</span>
              </PhoneGreeting>
            </PhoneTop>
            <SunsBanner>☀️ 23 suns up today</SunsBanner>
            <FeedCard>
              <FeedHeader>
                <FeedAvatar>🧘</FeedAvatar>
                <FeedName>
                  Morning meditation <em>· day 47</em>
                </FeedName>
              </FeedHeader>
              <FeedNote>“Sunrise walk before work. Feeling grateful.”</FeedNote>
              <Reactions>
                <span>🔥 3</span>
                <span>☀️ 2</span>
                <span>💪 1</span>
              </Reactions>
            </FeedCard>
            <FeedCard gold>
              <FeedHeader>
                <FeedAvatar>🏃</FeedAvatar>
                <FeedName>
                  Daily run <em>· day 200</em>
                </FeedName>
              </FeedHeader>
              <FeedNote>🌟 Golden sun! 200 days of showing up.</FeedNote>
              <Reactions>
                <span>🎉 5</span>
                <span>🔥 4</span>
                <span>☀️ 3</span>
              </Reactions>
            </FeedCard>
            <PhoneButton>Make today Day One ☀️</PhoneButton>
          </Phone>
        </PhoneWrapper>
      </Flex>
    </Container>
  </HeaderWrapper>
)

export default Header

const HeaderWrapper = styled.header`
  background: linear-gradient(160deg, #fff8ec 0%, #ffefd2 55%, #ffe3b8 100%);
  padding: 150px 0 100px 0;
  position: relative;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 calc(100% - 5vw));
  @media (max-width: ${(props) => props.theme.screen.sm}) {
    padding: 100px 0 80px 0;
  }
`

const Subtitle = styled.h5`
  font-size: 16px;
  color: #db9840;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 16px;
  text-align: left;

  @media (max-width: ${(props) => props.theme.screen.md}) {
    text-align: center;
  }
`

const Sun = styled.span`
  display: inline-block;
`

const HeaderTextGroup = styled.div`
  margin: 0;
  align-self: center;

  h1 {
    margin: 0 0 20px 0;
    font-size: 46px;
    line-height: 52px;
    color: ${(props) => props.theme.color.primary};

    @media (max-width: ${(props) => props.theme.screen.lg}) {
      font-size: 38px;
      line-height: 44px;
    }
    @media (max-width: ${(props) => props.theme.screen.sm}) {
      font-size: 32px;
      line-height: 38px;
    }
  }

  h2 {
    margin-bottom: 32px;
    font-size: 20px;
    line-height: 30px;
    font-family: ${(props) => props.theme.font.normal};
    color: ${(props) => props.theme.color.black.light};
    @media (max-width: ${(props) => props.theme.screen.sm}) {
      font-size: 17px;
      line-height: 26px;
    }
  }
`

const StoreBadges = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  a img {
    height: 52px;
    width: auto;
    display: block;
    transition: transform 0.15s ease;
  }

  a:hover img {
    transform: translateY(-2px);
  }

  @media (max-width: ${(props) => props.theme.screen.md}) {
    justify-content: center;
  }
`

const FreeLine = styled.p`
  margin-top: 16px;
  font-size: 14px;
  color: ${(props) => props.theme.color.black.lightest};
  @media (max-width: ${(props) => props.theme.screen.md}) {
    text-align: center;
  }
`

const Flex = styled.div`
  display: grid;
  justify-content: space-between;
  align-content: center;
  grid-template-columns: 1.1fr 0.9fr;
  grid-column-gap: 48px;
  @media (max-width: ${(props) => props.theme.screen.md}) {
    grid-template-columns: 1fr;
    text-align: center;
    display: flex;
    flex-direction: column-reverse;
  }
`

const PhoneWrapper = styled.div`
  justify-self: center;
  align-self: center;
  @media (max-width: ${(props) => props.theme.screen.md}) {
    margin-bottom: 40px;
  }
`

const Phone = styled.div`
  width: 300px;
  background: #ffffff;
  border-radius: 36px;
  border: 8px solid ${(props) => props.theme.color.primary};
  box-shadow: 0 24px 60px rgba(219, 152, 64, 0.35);
  padding: 24px 18px 18px;
  text-align: left;
  @media (max-width: ${(props) => props.theme.screen.sm}) {
    width: 270px;
    padding: 20px 14px 14px;
  }
`

const PhoneTop = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 14px;
`

const AvatarAura = styled.div`
  border-radius: 50%;
  padding: 4px;
  background: conic-gradient(#ffde59, #ff9d5c, #ffde59, #ffb347, #ffde59);
  box-shadow: 0 0 18px rgba(255, 179, 71, 0.8);
`

const Avatar = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #fff4e3;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
`

const PhoneGreeting = styled.div`
  display: flex;
  flex-direction: column;

  strong {
    font-family: ${(props) => props.theme.font.bold};
    color: ${(props) => props.theme.color.primary};
    font-size: 18px;
  }

  span {
    font-size: 13px;
    color: ${(props) => props.theme.color.black.light};
  }
`

const SunsBanner = styled.div`
  background: linear-gradient(90deg, #fff2d6 0%, #ffe3b8 100%);
  color: #a86a1c;
  font-family: ${(props) => props.theme.font.semibold};
  font-size: 14px;
  border-radius: 14px;
  padding: 10px 14px;
  text-align: center;
  margin-bottom: 14px;
`

const FeedCard = styled.div`
  background: ${(props) =>
    props.gold
      ? "linear-gradient(90deg, #FFF6DC 0%, #FFE9AE 100%)"
      : "#faf9f8"};
  border: 1px solid ${(props) => (props.gold ? "#F0C75E" : "#f0eeec")};
  border-radius: 16px;
  padding: 12px 14px;
  margin-bottom: 12px;
`

const FeedHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
`

const FeedAvatar = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid #f0eeec;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
`

const FeedName = styled.div`
  font-family: ${(props) => props.theme.font.semibold};
  font-size: 13px;
  color: ${(props) => props.theme.color.primary};

  em {
    font-style: normal;
    font-family: ${(props) => props.theme.font.normal};
    color: ${(props) => props.theme.color.black.lightest};
  }
`

const FeedNote = styled.p`
  margin: 0 0 8px;
  font-size: 13px;
  line-height: 18px;
  color: ${(props) => props.theme.color.black.light};
`

const Reactions = styled.div`
  display: flex;
  gap: 6px;

  span {
    background: #ffffff;
    border: 1px solid #f0e2c8;
    border-radius: 999px;
    padding: 2px 8px;
    font-size: 12px;
  }
`

const PhoneButton = styled.div`
  margin-top: 4px;
  background: linear-gradient(90deg, #ffb347 0%, #db9840 100%);
  color: #ffffff;
  font-family: ${(props) => props.theme.font.bold};
  font-size: 15px;
  text-align: center;
  border-radius: 999px;
  padding: 12px;
  box-shadow: 0 6px 16px rgba(219, 152, 64, 0.4);
`
